


function MyPartipationCard({ works,index }) {
  
  
  
  return (
    
        <>
            <div className="cardMyParticipation" >
           
                <div><span className="lw_time">{works.time}</span></div>
                <div className="lw_myParticipation">{works.title}</div>

                <div className="detailParticipation">

                <span className="swiperMyParticipations_first">
                    <a href={works.url} >
                        <img src={works.img} alt={works.title} />
                    </a>
                </span>

                <span className="swiperMyParticipations_second">{works.detail}</span>
                
                </div>
           </div>
       

        </>
        
        
       
    

  );
}

export default MyPartipationCard;